import React from 'react';
import { Container } from 'react-bootstrap';
import Video from '../Video/Video';

function StandaloneVideo({ youtubeVideoLink }) {
  return (
    <Container as="section" className="py-5">
      <Video youtubeVideoLink={youtubeVideoLink} />
    </Container>
  );
}

export default StandaloneVideo;
